import React from "react";
import { AppCard, AppCardContent } from "./Generic/AppCard";
import QuestionHeader from "./QuestionHeader";
import { RequiredDocAnswerableQuestionProps } from "./RequiredDocAnswerableQuestion";
import classNames from "classnames";

interface Props extends RequiredDocAnswerableQuestionProps {
  firstNumber: string | null;
  secondNumber: string | null;
}

const RequiredDocBloodPressure = ({
  questionId,
  questionText,
  firstNumber,
  secondNumber,
  isRequired,
  readonly,
  isValid,
  notes,
  onClickWhileDisabled,
  handleOnInsertAnswer,
}: Props) => {
  const handleMeasure = React.useCallback(
    (value: string, measureIndex: number) => {
      const newAnswers: string[] = [];
      if (firstNumber === null && secondNumber === null) {
        if (measureIndex === 0) {
          newAnswers[0] = value;
          newAnswers[1] = "";
        } else {
          newAnswers[0] = "";
          newAnswers[1] = value;
        }
      } else {
        if (measureIndex === 0) {
          newAnswers[0] = value;
          newAnswers[1] = secondNumber === null ? "" : secondNumber;
        } else {
          newAnswers[0] = firstNumber === null ? "" : firstNumber;
          newAnswers[1] = value;
        }
      }
      handleOnInsertAnswer(questionId, newAnswers);
    },
    [questionId, firstNumber, secondNumber, handleOnInsertAnswer]
  );

  const handleClickWhileDisabled = React.useCallback(() => {
    if (readonly && onClickWhileDisabled !== undefined) {
      onClickWhileDisabled();
    }
  }, [readonly, onClickWhileDisabled]);

  return (
    <AppCard
      className={classNames({ __invalid: !isValid })}
      style={{ margin: "8px 16px" }}
      onClick={() => handleClickWhileDisabled}
    >
      <QuestionHeader
        text={questionText}
        isRequired={isRequired && !readonly}
        notes={notes}
        isReadonly={readonly}
      />
      <AppCardContent>
        <div className="RequiredDocBloodPressure">
          <div className="RequiredDocBloodPressure_bloodPressureInputBox">
            <input
              type="number"
              pattern="\\d*"
              disabled={readonly}
              className="ScheduledVisitDocScreen__margin ScheduledVisitDocScreen__block text-input text-input--material"
              onChange={(event: any) => {
                handleMeasure(event.target.value, 0);
              }}
              value={firstNumber === null ? "" : firstNumber}
            />
          </div>
          <span className="RequiredDocBloodPressure_bloodPressureSeperator">/</span>
          <div className="RequiredDocBloodPressure_bloodPressureInputBox">
            <input
              type="number"
              pattern="\\d*"
              disabled={readonly || firstNumber === null}
              className="ScheduledVisitDocScreen__margin ScheduledVisitDocScreen__block text-input text-input--material"
              onChange={(event: any) => {
                handleMeasure(event.target.value, 1);
              }}
              value={secondNumber === null ? "" : secondNumber}
            />
          </div>
        </div>
      </AppCardContent>
    </AppCard>
  );
};

export default React.memo(RequiredDocBloodPressure);
